import(/* webpackMode: "eager", webpackExports: ["FadeIn","StaggerContainer","StaggerItem"] */ "/vercel/path0/components/effects/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
